import { render, staticRenderFns } from "./UirLine.vue?vue&type=template&id=47f0b31a&scoped=true"
import script from "./UirLine.vue?vue&type=script&lang=js"
export * from "./UirLine.vue?vue&type=script&lang=js"
import style0 from "./UirLine.vue?vue&type=style&index=0&id=47f0b31a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f0b31a",
  null
  
)

export default component.exports